import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';

import {
  Input,
  InputField,
  Date,
  DateField,
  RemoteAutoCompleteField,
  RemoteAutoComplete,
  ToggleField,
  Toggle,
  FormattedNumberInput
} from '@components/form';
import { RepairType } from '@modules/repairs/_repairsEnums';
import { required, isPositive } from '@utils/validators';
import { floatOnly, formatToDecimals } from '@utils/utils';

const View: React.SFC<any> = ({ change, type, disabled }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={6} xl={3}>
          <Row>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                disabled={disabled}
                label="Vozidlo *"
                name="vehicle"
                id="vehicle"
                url="/metropolis/api/cl/vehicles"
                fullWidth={true}
                labelFunction={o => get(o, 'fullName')}
                validate={[required]}
                onChange={v => change('mileage', get(v, 'mileage'))}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ marginTop: 15 }}>
                <ToggleField
                  component={Toggle}
                  disabled={disabled}
                  name="locked"
                  id="locked"
                  label={`${type === RepairType.REPAIR ? 'Oprava' : 'Údržba'} uzamknuta`}
                  labelPosition="left"
                  formChange={change}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DateField
                disabled={disabled}
                component={Date}
                name={'repairTime'}
                id={'repairTime'}
                label={`Datum ${
                  type === RepairType.REPAIR ? 'opravy' : RepairType.MAINTENANCE ? 'údržby *' : 'údržby'
                }`}
                dateOnly={false}
                validate={type === RepairType.MAINTENANCE ? [required] : []}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                disabled={disabled}
                id={'repairs-form-mileage'}
                name={'mileage'}
                label={'Stav km *'}
                type={'number'}
                min={0}
                validate={[isPositive, required]}
              />
            </Col>
          </Row>
          {type === RepairType.REPAIR && (
            <Row>
              <Col md={12}>
                <InputField
                  component={Input}
                  disabled={disabled}
                  multiLine={true}
                  name="reportDescription"
                  id="reportDescription"
                  label={'Popis závady'}
                  style={{ maxHeight: '60vh' }}
                  inputStyle={{ maxHeight: '60vh' }}
                  textareaStyle={{ maxHeight: '56vh' }}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                disabled={disabled}
                multiLine={true}
                name="repairDescription"
                id="repairDescription"
                label={`Popis ${type === RepairType.REPAIR ? 'opravy *' : 'údržby *'}`}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
                validate={[required]}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                disabled={disabled}
                component={FormattedNumberInput}
                id={'price'}
                name={'price'}
                label={'Cena s DPH'}
                normalize={floatOnly}
                format={v => formatToDecimals(v)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);
export const RepairsCreateFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsCreateFormBasic.tsx